import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetLocationList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Location/GetLocationList?` + params, null, undefined, sToken);

export const GetReasonForReferenceList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReasonForReference/GetList?` + params, null, undefined, sToken);

export const GetDoctorList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Doctor/GetList?` + params, null, undefined, sToken);

export const SaveNotificationLog = (data: any, sToken: string) =>
    POST_ENC(`${BASE_URL}/api/token/Notification/Save`, data, undefined, undefined, sToken);

export const GetReasonForVisitList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReasonForVisit/GetList?` + params, null, undefined, sToken);

export const SaveAppointment = (data: any, sToken: string) =>
    POST_ENC(`${BASE_URL}/api/token/Appointment/Create`, data, false, undefined, sToken);

export const GetAppointmentAvailabilityDateList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Appointment/AppointmentAvailabilityDate?` + params, null, undefined, sToken);

export const GetAppointmentAvailabilityList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Appointment/AppointmentAvailability?` + params, null, undefined, sToken);

export const GetPatientNumber = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Patient/GetPatientNumber?` + params, null, undefined, sToken);

export const GetTeamMemberList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/TeamMember/GetList?` + params, null, undefined, sToken);

export const GetTeamMemberLocationList = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/TeamMember/GetTeamMemberLocationList?` + params, null, undefined, sToken);

export const GetOpdDetailsForReport = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Report/GetOpdDetailsForReport?` + params, null, undefined, sToken);

export const GetPatient = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Appointment/GetPatient?` + params, null, undefined, sToken);

export const GetPatientReportCertificatePreview = (data: any, sToken: string) =>
    POST_ENC(`${BASE_URL}/api/token/ReportCertificate/GetPatientReportPreview`, data, undefined, undefined, sToken);
export const GetBillingTokenDetail = (params: any, sToken: string) =>
  GET_ENC(`${BASE_URL}/api/token/Report/GetBillingTokenDetail?` + params, null, undefined, sToken);

export const GetBillingReport = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/Report/GetBillingDetailsForReport?` + params, null, undefined, sToken);




export const GetReportCertificateTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/ReportCertificate/GetReportCertificateTokenDetail?` + params, null, undefined, sToken);

export const GetGrowthChartTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/GrowthChart/GetGrowthChartTokenDetail?` + params, null, undefined, sToken);

export const GetGrowthChart = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/GrowthChart/GetGrowthChart?` + params, null, undefined, sToken);

export const GetFullPrescriptionTokenDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/FullPrescriptionReport/GetFullPrescriptionTokenDetail?` + params, null, undefined, sToken);

export const GetFullPrescriptionReportDetail = (params: any, sToken: string) =>
    GET_ENC(`${BASE_URL}/api/token/FullPrescriptionReport/GetFullPrescriptionReportDetail?` + params, null, undefined, sToken);
